import axios from "axios";
import { rotaDeProducao } from "./rotas";

/**
 * 
 * @param {*} cnpj 
 * @param {*} numeroEmpresaFK 
 * @param {*} dadosPagamento 
 * @returns {Promise}
 */
export async function apiMercadoPagoCriarPagamento(cnpj, numeroEmpresaFK, dadosPagamento) {
    let cnpjConvertido = cnpj.replaceAll(",", "").replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
    const url = rotaDeProducao() + "/pagar"

    const body = {
        cnpj: cnpjConvertido,
        numeroEmpresaFK: numeroEmpresaFK, 
        dadosPagamento: dadosPagamento, 
    }
    console.log("body do pagamento")
    console.log(body)
    return new Promise((resolve, reject) => {
        axios.post(url, body).then((response) => {
            console.log("===================================================")
            console.log("resposta")
            console.log(response.data)
            resolve(response.data)
        })
        .catch((err) => {
            console.log("deu erro no mercadopago")
            console.log(err)
            reject(err)
        })
    })
}

/**
 * 
 * @param {*} cnpj 
 * @param {*} numeroEmpresaFK 
 * @param {*} pagamento_id 
 * @returns {Promise}
 */
export async function apiMercadoPagoBuscarStatusPagamento(cnpj, numeroEmpresaFK, pagamento_id) {
    let cnpjConvertido = cnpj.replaceAll(",", "").replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
    const url = rotaDeProducao() + `/pagamentoStatus?cnpj=${cnpjConvertido}&numeroEmpresaFK=${numeroEmpresaFK}&pagamento_id=${pagamento_id}`

    return new Promise((resolve, reject) => {
        axios.get(url).then((response) => {
            console.log("resposta do apiMercadoPagoBuscarStatusPagamento")
            console.log(response.data)
            resolve(response.data)
        })
        .catch((err) => {
            reject(err)
        })
    })
}


// {
//   "id": 20359978,
//   "date_created": "2019-07-10T14:47:58.000Z",
//   "date_approved": null,
//   "date_last_updated": "2019-07-10T14:47:58.000Z",
//   "money_release_date": null,
//   "issuer_id": 25,
//   "payment_method_id": "pix",
//   "payment_type_id": "credit_card",
//   "status": "approved",
//   "status_detail": "accredited",
//   "currency_id": "BRL",
//   "description": "Point Mini a maquininha que dá o dinheiro de suas vendas na hora.",
//   "taxes_amount": 0,
//   "shipping_amount": 0,
//   "collector_id": 448876418,
//   "payer": {
//     "id": 123,
//     "email": "test_user_br@testuser.com",
//     "identification": {
//       "number": "19119119100",
//       "type": "CPF"
//     },
//     "type": "customer"
//   },
//   "metadata": {},
//   "additional_info": {
//     "items": [
//       {
//         "id": "PR0001",
//         "title": "Point Mini",
//         "description": "Producto Point para cobros con tarjetas mediante bluetooth",
//         "picture_url": "https://http2.mlstatic.com/resources/frontend/statics/growth-sellers-landings/device-mlb-point-i_medium2x.png",
//         "category_id": "electronics",
//         "quantity": 1,
//         "unit_price": "24.50"
//       }
//     ],
//     "payer": {
//       "registration_date": "2019-01-01T15:01:01.000Z"
//     },
//     "shipments": {
//       "receiver_address": {
//         "street_name": "Av das Nacoes Unidas",
//         "street_number": "3003",
//         "zip_code": "06233-903",
//         "city_name": "Osasco",
//         "state_name": "SP"
//       }
//     }
//   },
//   "external_reference": "MP0001",
//   "transaction_amount": "24.50",
//   "transaction_amount_refunded": 50,
//   "coupon_amount": 15,
//   "transaction_details": {
//     "net_received_amount": 56,
//     "total_paid_amount": "50.00",
//     "overpaid_amount": 0,
//     "installment_amount": 58
//   },
//   "fee_details": [
//     {
//       "type": "coupon_fee",
//       "amount": 2,
//       "fee_payer": "payer"
//     }
//   ],
//   "statement_descriptor": "MercadoPago",
//   "installments": 1,
//   "card": {
//     "id": null,
//     "first_six_digits": null,
//     "last_four_digits": 5682,
//     "expiration_month": null,
//     "expiration_year": null,
//     "date_created": null,
//     "date_last_updated": null,
//     "cardholder": {
//       "name": null,
//       "identification": {
//         "number": "19119119100",
//         "type": "CPF"
//       }
//     }
//   },
//   "notification_url": "https://www.suaurl.com/notificacoes/",
//   "processing_mode": "aggregator",
//   "point_of_interaction": {
//     "type": "pix",
//     "application_data": {
//       "name": "NAME_SDK",
//       "version": "VERSION_NUMBER"
//     },
//     "transaction_data": {
//       "qr_code_base64": "iVBORw0KGgoAAAANSUhEUgAABRQAAAUUCAYAAACu5p7oAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAIABJREFUeJzs2luO3LiWQNFmI+Y/Zd6vRt36KGNXi7ZOBtcagHD4kNLeiLX33v8DAAAAABD879sDAAAAAAA/h6AIAAAAAGSCIgAAAACQCYoAAAAAQCYoAgAAAACZoAgAAAAAZIIiAAAAAJAJigAAAABAJigCAAAAAJmgCAAAAABkgiIAAAAAkAmKAAAAAEAmKAIAAAAAmaAIAAAAAGSCIgAAAACQCYoAAAAAQCYoAgAAAACZoAgAAAAAZIIiAAAAAJAJigAAAABAJigCA...",
//       "qr_code": "00020126600014br.gov.bcb.pix0117test@testuser.com0217dados adicionais520400005303986540510.005802BR5913Maria Silva6008Brasilia62070503***6304E2CA",
//       "ticket_url": "https://www.mercadopago.com.br/payments/123456789/ticket?caller_id=123456&hash=123e4567-e89b-12d3-a456-426655440000"
//     }
//   }
// }